module.exports = __webpack_public_path__ + "static/media/5DPO23.bb43d230.jpg";